import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AppContext } from '../../../context/appContext';
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { GetApiContext } from "../../../context/apiCalls/getApiCalls";

export default function ProspectPopList() {
    const getApiCalls = useContext(GetApiContext);
    const appContext = useContext(AppContext);
    const [prospects, setProspects] = useState([]);

    let { id } = useParams();

    useEffect(() => {
        getApiCalls.getProspectsList(id)
            .then(response => {
                setProspects(response?.listProspectings || []);
                appContext.setReload(false);
            });
    }, [appContext.reload, appContext, getApiCalls, id]);

    const closePop = () => {
        appContext.setBlur(false);
        appContext.setShowProspectListPopup(false);
    };

    const editProspect = (id) => {
        appContext.setIdprospect(id);
        appContext.setShowEditProspectPopup(!appContext.showEditProspectPopup);
        appContext.setBlur(true);
        appContext.setShowProspectListPopup(false);
    };

    return (
        <div className='tablePop'>
            <h3 className='titlePop'>Liste des prospects</h3>
            <div className='borderForm'>
                <table className='tableForm'>
                    <thead>
                        <tr>
                            <th className='thForm th1'>Appel</th>
                            <th className='thForm th2'>Rendez-vous</th>
                            <th className='thForm th3'>Relance</th>
                            <th className='thForm th4'>Commentaire</th>
                            <th className='thForm th5'>Modifier</th>
                        </tr>
                    </thead>
                    <tbody className='tbody'>
                        {prospects && prospects.length > 0 ? prospects.map((element, index) => (
                            <tr className='tr' key={index}>
                                <td className='tdForm td1'>{element?.call || "vide"}</td>
                                <td className='tdForm td2'>{element?.meeting || "vide"}</td>
                                <td className='tdForm td3'>{element?.dunning || "vide"}</td>
                                <td className='tdForm td4'>{element?.comment || "comment vide"}</td>
                                <td className='tdEdit tdForm'>
                                    <FontAwesomeIcon onClick={() => editProspect(element.id)} className='editIcon' icon={faPenToSquare} />
                                </td>
                            </tr>
                        )) : (
                            <tr className='tr'>
                                <td className='tdForm td1'>vide</td>
                                <td className='tdForm td2'>vide</td>
                                <td className='tdForm td3'>vide</td>
                                <td className='tdForm td4'>vide</td>
                                <td className='tdEdit tdForm'></td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <p className='pop-up-cancel' onClick={closePop}>fermer</p>
        </div>
    );
}